<markdown [data]="markdown"></markdown>

<button type="button" (click)="_location.back()">
  Go back</button>
